import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,
  MDBCardText,
  MDBTable,
  MDBTableHead,
  MDBTableBody


}
from 'mdb-react-ui-kit';
import '../../../css/index.css';
import Popup from '../../Popup/popUp';


function CriarCheckinD() {

  const location = useLocation();
  const parametro = location.state.obj;
  const navigate = useNavigate(); 
  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const api = require('../../../apis/checkin')
  const apiFilial = require('../../../apis/filial')
  

  const apiAluno = require('../../../apis/aluno')
  
  const [checked, setChecked] = useState(false);
  const [userLocation, setUserLocation] = useState(null);
  const [databaseLocation, setDatabaseLocation] = useState({
    latitude: 0, // Latitude do banco de dados
    longitude: 0, // Longitude do banco de dados
  });
  const [radius, setRadius] = useState(); // Raio em quilômetros

  useEffect(() => {
    

    const getCoord = async () => {
      const result = await apiFilial.pegarCoordenadasFilialApi({
        idFilial: parametro.idfilial,
        idEscola: parametro.idescola,
      })
      if(!result){
        toast.error('Checkin não habilitado pra sua filial!');
        navigate("/area-checkin")
        return
      }

      setDatabaseLocation({
        latitude: parseFloat(result[0].latitude),
        longitude: parseFloat(result[0].longitude)
      });
      setRadius(parseInt(result[0].raio) / 1000);
    }
    // Função para obter a localização do usuário
    const getUserLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setUserLocation({ latitude, longitude });
          },
          (error) => {
            toast.error('Erro ao obter a localização do usuário:', error.message);
            navigate("/area-checkin")
          }
        );
      } else {
        toast.error('Geolocalização não suportada pelo navegador.');
        navigate("/area-checkin")
      }
    };

    

    // Chama a função para obter a localização do usuário
    getCoord();
    getUserLocation();
  }, []); // Executa apenas uma vez quando o componente é montado
  useEffect(() => {
    // Função para verificar se o usuário está dentro do raio
    const isUserWithinRadius = () => {
      if (userLocation && databaseLocation && radius) {
        const { latitude: userLat, longitude: userLng } = userLocation;
        const { latitude: dbLat, longitude: dbLng } = databaseLocation;
  
        // Fórmula haversine para calcular a distância entre duas coordenadas
        const R = 6371; // Raio da Terra em quilômetros
        const dLat = (userLat - dbLat) * (Math.PI / 180);
        const dLng = (userLng - dbLng) * (Math.PI / 180);
        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(userLat * (Math.PI / 180)) * Math.cos(dbLat * (Math.PI / 180)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;
  
        // Verifica se a distância está dentro do raio
        if (distance <= radius) {
          toast.success('Usuário está dentro do raio.');
          setChecked(true);
        } else {
          toast.error('Usuário está fora do raio.');
        }
      }
    };

    // Chama a função para verificar se o usuário está dentro do raio
    isUserWithinRadius();
  }, [userLocation, databaseLocation, radius]);

  
  
  const [data, setData] = useState([]);

  const [matriculaResponsavel, setMatriculaResponsavel] = useState("");

  const [alunosMarcados, setAlunosMarcados] = useState([]);

  const [botoesDesabilitados, setBotoesDesabilitados] = useState([]);

  const handleClick = async(obj) => {
    setBotoesDesabilitados((prevState) => {
      const novosBotoesDesabilitados = [...prevState];
      novosBotoesDesabilitados[obj.id] = true;
      return novosBotoesDesabilitados;
    });
    setAlunosMarcados((prevState) => [...prevState, obj]);
  }

  const handleSubmit = async () => {
    const today = util.getMySQLDate(); // Obtém a data atual no formato MySQL
  
    for (const objeto of alunosMarcados) {
      
      try {
        const objReq = {
          idAluno: objeto.ra
        }
        const ultimaDataCheckin = await api.ultimoCheckin(objReq);

        console.log(today);
        console.log(ultimaDataCheckin[0]);
        
        if (ultimaDataCheckin[0] != undefined ? ultimaDataCheckin[0].dataformatada == today : false) {
          toast.warning(`Check-in para ${objeto.nomealuno} já foi feito hoje.`);
          setShowPopup(false);
          setAlunosMarcados([]);
          setData([]);
          setBotoesDesabilitados([]);

        } else {
          const obj = {
            responsavel: userLogin.nomeres,
            aluno: objeto.nomealuno,
            turma: objeto.codturma,
            data: today,
            dataConfirmacao: today,
            idAluno: objeto.ra,
            idResponsavel: userLogin.cpf,
            idTurma: objeto.codturma,
            idFilial: objeto.idfilial,
            idEscola: objeto.idescola
          };
  
          const result = await api.registrarCheckinApi(obj);
  
          console.log(result);
  
          if (result) {
            toast.success(`Check-in para ${objeto.nomealuno} informado!`);
            handlePopupClose();
          } else {
            toast.error("Erro ao fazer check-in!");
          }
        }
      } catch (error) {
        console.error("Erro durante a chamada da API:", error);
        toast.error("Erro ao fazer check-in!");
      }
    }
  };

  /*const handleSubmit = () => {
    
    alunosMarcados.forEach(async objeto => {
      const obj = ({
        responsavel: userLogin.nomeres,
        aluno: objeto.nomealuno,
        turma: objeto.codturma,
        data: util.getDate(),
        dataConfirmacao: util.getDate(),
        idAluno: objeto.ra,
        idResponsavel: userLogin.cpf,
        idTurma: objeto.codturma,
        idFilial: objeto.idfilial,
        idEscola: objeto.idescola
      })
      
      const result = await api.registrarCheckinApi(obj);

      console.log(result)
      
      result ? toast.success(`Checkin para ${objeto.nomealuno} informado!`) && handlePopupClose():  toast.error("Error ao fazer checkin!")
    })
    ;
    
  }*/

  const [showPopup, setShowPopup] = useState(false);

  const handleButtonClick = async () => {
    const getAlunos = async () => {
      try {
        const object = {
          cpf: matriculaResponsavel,
          idFilial: parametro.idfilial
        };
        console.log(object)
        const response = await apiAluno.pegarAlunoPorResponsavelApi(object);
        const data = await response;
        console.log(data)
        setData(data);
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };
    await getAlunos();
    setShowPopup(true)

  };

  const handlePopupClose = () => {
    setShowPopup(false);
    setAlunosMarcados([]);
    setData([]);
    setBotoesDesabilitados([]);
  };
  

  const [formValue, setFormValue] = useState({
    responsavel: '',
    aluno: '',
    turma: '',
    data: '',
    idAluno: '',
    idResponsavel: '',
    idTurma: '',
    idFilial: '',
    idEscola: ''
  });
  useEffect(() => {
    const preencherCampos = async () => {
      setMatriculaResponsavel(userLogin.cpf)
    };

    preencherCampos();
  }, [matriculaResponsavel]);

  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
       minHeight:'500px',display:"flex", justifyContent:"center", alignItemsalignItems:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex flex-column align-items-center'>

          <MDBCard className='bg-dark text-white h-75 w-75' style={{borderRadius: '1rem', minWidth: '300px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

              <MDBCardTitle className='text-white my-5'>Bem vindo, {util.decideName(userLogin)}</MDBCardTitle>
                  <MDBValidation className='w-100' onSubmit={handleSubmit}>
                    <div className='d-flex justify-content-between'>
                    <MDBValidationItem style={{width:'100%', opacity:0.4}} feedback='Por favor digite a matricula do responsável' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100'
                          className='bg-dark' 
                          labelClass='text-white' 
                          label='Matricula do responsável' id='formControMatriculaResponsavel' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='matriculaResponsavel'
                          value={matriculaResponsavel || ''}
                          disabled={!matriculaResponsavel}
                          required
                          minLength={3}
                          
                          />
                        
                      </MDBValidationItem>
                      <Popup show={showPopup} handleClose={handlePopupClose}>

                        <div className='d-flex justify-content-center flex-column align-items-center w-100'>
                          {data.map((user) => (
                            <div className='d-flex justify-content-between m-2 flex-row align-items-between w-100' key={user.id}>
                              <MDBInput 
                                className='w-100 bg-dark'
                                labelClass='text-white' 
                                label='Nome do aluno' id='formControNomeAluno' 
                                type='text' 
                                size="lg" 
                                style={{color:"white", opacity:0.6}}
                                name='nomeAluno'
                                value={user.nomealuno}
                                required
                                disabled={true}
                                minLength={3}
                              
                              />
                              <MDBBtn 
                              className='btn-home w-50'
                              size='sm'
                              outline 
                              type='button'
                              color='white' 
                              onClick={() => handleClick(user)}
                              disabled={botoesDesabilitados[user.id]}
                              >Marcar</MDBBtn>
                            </div>
                          ))}
                          
                        </div>
                        <MDBBtn 
                            className='btn-home mt-5 w-100'
                            size='lg'
                            outline 
                            color='white' 
                            type='submit'
                            id='submitForm'
                          >Checkin</MDBBtn>
                          
                          </Popup>
                    </div>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 btn-home' 
                        color='white' 
                        size='lg'
                        type='button'   
                        id='submitForm'
                        disabled={!checked}  
                        onClick={handleButtonClick}
                        >
                        
                        Buscar
                      </MDBBtn>
                      
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        id='submitForm'
                        onClick={() => {
                          navigate("/area-checkin")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                    
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default CriarCheckinD;